export const HilDecision = {
  Approved:  'approved',
  Rejected:  'rejected',
  Submitted: 'submitted',
  Replied:   'replied',
  Escalated: 'escalated',
  Cancelled: 'cancelled',
  Abstained: 'abstained',
} as const;

export type HilDecisionValue = typeof HilDecision[keyof typeof HilDecision];
